$(document).on('click', '.remove-pp', function(evt){
  let pricePointForm = $(this).closest('fieldset');
  let markToDelete = $(this).siblings('input:hidden')[0];
  let fields = $(this).siblings('input')
  $(fields[0]).removeAttr('required')
  $(fields[1]).removeAttr('required')
  $(fields[2]).removeAttr('required')
  // let checkBox = $(pricePointForm).find('.default-price-checkbox')[0]
  
  $(markToDelete).val(true)
  pricePointForm.css('display', 'none');
  evt.preventDefault();
});

function validateDefaultPricePointSelection(pricePoints) {
  if (pricePoints.length > 1){
    return { valid: false, className: 'invalid', message: '<i class="fa fa-times-circle"></i> You can only set one default Price Point.' }
  } else if (pricePoints.length < 1) {
    return { valid: false, className: 'invalid', message: '<i class="fa fa-times-circle"></i> To save your camp successfully please set 1 default Price Point.'}
  }
  else if (pricePoints.length == 1) {
    return { valid: true, className: 'valid', message: '<i class="fa fa-check-circle"></i> Success!' }
  } else {
    return { valid: false, className: 'invalid', message: '<i class="fa fa-times-circle"></i> Error - please contact support@firewoodcamps.com' }
  }
}
let defaultPricPointCheckbox = document.querySelector('.default-price-checkbox')
if (defaultPricPointCheckbox){
  document.querySelector('.default-price-checkbox').addEventListener('click', e => {
    let validationMessageDiv = document.getElementById('price-point-validation-message')
    validationMessageDiv.innerHTML = ''
    let defaultPricePointCount = document.querySelectorAll('.default-price-checkbox:checked')
    validationMessageDiv.classList.remove('valid')
    let validationTuple = validateDefaultPricePointSelection(defaultPricePointCount)
    validationMessageDiv.classList.add(validationTuple['className'])
    validationMessageDiv.innerHTML = validationTuple['message']
  });
}

$(document).on('click', '.add_fields', function(evt){
  let time = new Date().getTime();
  let regexp = new RegExp($(this).data('id'), 'g');
  let item = $(this)[0];
  let itemType = $(item).data('item-type');
  $(this).before($(this).data('fields').replace(regexp, time));
  if (itemType == 'price_point'){
    const priceCheckboxes = document.querySelectorAll(".default-price-checkbox")
    for (const priceCheckbox of priceCheckboxes) {
      priceCheckbox.addEventListener('click', function(e) {
        let validationMessageDiv = document.getElementById('price-point-validation-message')
        validationMessageDiv.innerHTML = ''
        let defaultPricePointCount = document.querySelectorAll('.default-price-checkbox:checked')
        validationMessageDiv.classList.remove('valid')
        let validationTuple = validateDefaultPricePointSelection(defaultPricePointCount)
        validationMessageDiv.classList.add(validationTuple['className'])
        validationMessageDiv.innerHTML = validationTuple['message']
      })
    }
  }
  evt.preventDefault()
});

$('#camp_age').selectize({
  sortField: 'age',
  maxItems: 1,
  create: function(input, callback) {
    callback({
      value: input,
      text: input
    });
  }
});

$(document).on('click', '.camp-delete-link', function(evt){   
  let url = $(this).attr('href');
  let campId = $(this).data('id');
  conole.log(url);

  $.ajax({
    url: url,
    method: "DELETE",
    data: {},
    dataType: "json"
  }).done(function(data){
    location.reload();
    if (data.status.toString() == '200'){
     
    }
    else {

    }
  });
});